'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var HEADERS = exports.HEADERS = {
    ACCEPT: 'Accept'
};

var ERROR_CODES = exports.ERROR_CODES = {
    CONNECTION_ABORTED: 'ECONNABORTED',
    CONNECTION_RESET: 'ECONNRESET',
    CONNECTION_REFUSED: 'ECONNREFUSED'
};

var METHODS = exports.METHODS = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete',
    COPY: 'copy'
};


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/http/httpConstants.js
// module id = 90
// module chunks = 0